import { render, staticRenderFns } from "./EventDialog.vue?vue&type=template&id=f21d4630&scoped=true"
import script from "./EventDialog.vue?vue&type=script&lang=js"
export * from "./EventDialog.vue?vue&type=script&lang=js"
import style0 from "./EventDialog.vue?vue&type=style&index=0&id=f21d4630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21d4630",
  null
  
)

export default component.exports